const arr = [];
for (let i = 2; i < 35; i++) {
  arr.push({
    url: require(`@/assets/images/journey/normal/画板 1 拷贝 ${i}.jpg`)
  });
}
export default [
  {
    url: require("@/assets/images/journey/normal/画板 1.jpg")
  },
  {
    url: require("@/assets/images/journey/normal/画板 1 拷贝.jpg")
  },
  ...arr
];
